module.exports = __webpack_public_path__ + "img/lotto_4profitshare.67530ee.png";